module.exports = __webpack_public_path__ + "img/orange_062.592eda76.png";